module.exports = __webpack_public_path__ + "img/main-collage.02820def.jpg";